import { selectHelper } from '../../common/helpers'
import { messages } from '../../common/constants'


export const selectStoresForSelect = (state) => {
    const { stores } = state.store.storeList
    var storeValues = []

    if (!stores || stores.length == 0) return storeValues
    storeValues = selectHelper.getValuesForSelect(stores, 'id', 'name', messages.SELECT_ALL_VALUES)
    return storeValues
}

export const selectStoresForSelectQuotation = (state) => {
    const { stores } = state.store.storeList
    var storeValues = []

    if (!stores || stores.length == 0) return storeValues
    storeValues = selectHelper.getValuesForSelect(stores, 'id', 'name')
    return storeValues
}


// WEBPACK FOOTER //
// ./src/store/store/selector.js